export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fb8b0fdc2b8cdc54c25c7cc0089a3c92585e08acf&name=fetchTypeahead!'